@if (canRequestService) {
<button mat-icon-button [matMenuTriggerFor]="menu" [attr.aria-label]="'actions' | translate" [matTooltip]="'actions' | translate" data-testid="por-cp-items-out-actions-menu">
    <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu" class="por-actions-menu">
    <button mat-menu-item (click)="requestService()" data-testid="por-cp-request-service-action">
        <span>{{ 'RequestService' | translate }}</span>
    </button>
</mat-menu>
}
